import { LayoutHeaderDefaultSearchTypeContext } from '#/layouts/Layout/Header/LayoutHeaderDefaultSearchTypeContext';
import { SearchRefinementsSwitch } from '#/modules/search/components/Refinements/SearchRefinementsSwitch';
import {
  useSearchFiltersByName,
  useSearchQuery,
} from '#/modules/search/contexts/SearchContext';
import { searchShouldShowSortOptions } from '#/modules/search/helpers/searchShouldShowSortOptions';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';
import type { SearchType } from '#/modules/search/types/SearchType';

import { MobileSearchFilterSortSection } from './MobileSearchFilterSortSection';

type Props = {
  searchType: SearchType;
  onChangeSort: (sort: SearchSortType) => void;
};

export function MobileSearchFilterModalContent({
  searchType,
  onChangeSort,
}: Props) {
  // Mirror desktop's sort gating so the two can't drift (sc-67240).
  const query = useSearchQuery();
  const filters = useSearchFiltersByName();
  const showSortOptions = searchShouldShowSortOptions({
    searchType,
    query,
    filters,
  });

  return (
    <>
      {showSortOptions && (
        <MobileSearchFilterSortSection onChangeSort={onChangeSort} />
      )}
      <LayoutHeaderDefaultSearchTypeContext value={searchType}>
        <SearchRefinementsSwitch variant="modal" />
      </LayoutHeaderDefaultSearchTypeContext>
    </>
  );
}
